import { classes } from '@/uiPrimitives/base/classes.helpers';
import { circleCSS, svgCSS } from './LoadingIndicator.css';
import { box } from '@/uiPrimitives/layout/box';
import { pile } from '@/uiPrimitives/layout/pile';

export const LoadingIndicator = () => (
	<>
		<div />
		<div
			className={classes(
				pile({ alignItems: 'center', justifyItems: 'center' }),
				box({ size: '100%' }),
			)}
		>
			<svg
				className={classes(svgCSS, box({ size: '3 | h1' }))}
				viewBox="25 25 50 50"
			>
				<circle className={classes(circleCSS)} r="20" cy="50" cx="50"></circle>
			</svg>
		</div>
	</>
);
